export default __webpack_public_path__ + "static/media/certificate.01b70d46.png";